import Home from './pages/Home';
import MapView from './pages/MapView';
import ReportIssue from './pages/ReportIssue';
import ReportDetails from './pages/ReportDetails';
import MyReports from './pages/MyReports';
import CityDashboard from './pages/CityDashboard';
import ContractorJobs from './pages/ContractorJobs';
import MyTasks from './pages/MyTasks';
import EstateDashboard from './pages/EstateDashboard';
import MonthlyReport from './pages/MonthlyReport';
import Profile from './pages/Profile';
import MyActivity from './pages/MyActivity';
import Leaderboard from './pages/Leaderboard';
import Settings from './pages/Settings';
import RoleSetup from './pages/RoleSetup';
import CreateEstate from './pages/CreateEstate';
import UpgradePage from './pages/UpgradePage';
import UpgradeSuccess from './pages/UpgradeSuccess';
import ManageSubscription from './pages/ManageSubscription';
import JoinEstate from './pages/JoinEstate';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import FAQ from './pages/FAQ';
import Layout from './Layout.jsx';


export const PAGES = {
    "Home": Home,
    "MapView": MapView,
    "ReportIssue": ReportIssue,
    "ReportDetails": ReportDetails,
    "MyReports": MyReports,
    "CityDashboard": CityDashboard,
    "ContractorJobs": ContractorJobs,
    "MyTasks": MyTasks,
    "EstateDashboard": EstateDashboard,
    "MonthlyReport": MonthlyReport,
    "Profile": Profile,
    "MyActivity": MyActivity,
    "Leaderboard": Leaderboard,
    "Settings": Settings,
    "RoleSetup": RoleSetup,
    "CreateEstate": CreateEstate,
    "UpgradePage": UpgradePage,
    "UpgradeSuccess": UpgradeSuccess,
    "ManageSubscription": ManageSubscription,
    "JoinEstate": JoinEstate,
    "Login": Login,
    "Signup": Signup,
    "ForgotPassword": ForgotPassword,
    "PrivacyPolicy": PrivacyPolicy,
    "TermsOfService": TermsOfService,
    "FAQ": FAQ,
}

export const pagesConfig = {
    mainPage: "Home",
    Pages: PAGES,
    Layout: Layout,
};